import React, {useMemo, useContext, useState} from 'react';
import produce from 'immer';
import pt from 'prop-types';

export default function makeStore() {
    // Make a context for the store
    const context = React.createContext();

    // Make a provider that takes an initialValue
    const StoreProvider = ({initialValue = {}, children} = {}) => {
        // TODO use immer
        const [state, setState] = useState(initialValue);
        const setImmerState = setter => setState(produce(setter));

        // Memoize the context value to update when the state does
        const contextValue = useMemo(() => [state, setImmerState], [state]);

        // Provide the store to children
        return <context.Provider value={contextValue}>{children}</context.Provider>;
    };

    StoreProvider.propTypes = {
        initialValue: pt.object,
        children: pt.oneOfType([pt.object, pt.array])
    };

    // A hook to help consume the store
    const useStore = () => useContext(context);

    return {StoreProvider, useStore};
}
